import { Theme } from "@mui/material";

export const SizeStyles = (theme: Theme) => {
  return {
    sm: {
      fontSize: theme.fontSizes.sm,
      width: "32px",
      height: "32px",
    },
    md: {
      fontSize: theme.fontSizes.md,
    },
    lg: {
      width: "48px",
      height: "48px",
      fontSize: theme.fontSizes.lg,
    },
  };
};

export const GradientStyles = (theme: Theme, hash: number) => {
  return {
    gradient1: {
      backgroundImage: theme.utils.linearGradient("horizontal", "blueToGreen"),
    },
    gradient2: {
      backgroundImage: theme.utils.linearGradient("horizontal", "pinkToPurple"),
    },
    gradient3: {
      backgroundImage: theme.utils.linearGradient("horizontal", "amberToRed"),
    },
    gradient4: {
      backgroundImage: theme.utils.linearGradient("vertical", "amberToGreen"),
    },
    gradient5: {
      backgroundImage: `linear-gradient(${hash % 360}deg, rgba(${hash % 255}, ${(hash * 2) % 255}, ${(hash * 3) % 255}), rgba(${(hash * 5) % 255}, ${(hash * 7) % 255}, ${(hash * 11) % 255}))`
    }
  };
};